// const devApiUrl = "https://hsjapidev.hulian120.com"; //本地开发环境
const devApiUrl = "https://hsjapidev.hulian120.com"; //本地开发环境
// const devApiUrl = "http://192.168.49.133:9088"; //栋哥本地
const buildDevApiUrl = "http://47.93.160.16:9088"; //打包开发环境
const buildLocaApiUrl = "http://localhost:9088"; //打包后端调试环境
const buildTestApiUrl = "http://47.93.160.16:9188"; //打包测试环境
const buildPreApiUrl = "https://hsjapidev.hulian120.com"; //打包预发布环境
const buildProApiUrl = "https://hsjapi.hulian120.com"; //打包正式环境

let useApiUrl,
  isRelease = false, //是否是线上发布版本
  h5LoginSystemUrl = "http://39.105.181.235:8088/webs/107/#/",
  // h5LoginSystemUrl = "http://39.105.181.235:8088/webs/107/#/",
  appDownloadUrl = "https://mw.hulian120.com/27/download.html",
  wxApiUrlPrefix = "https://devmpauth.hulian120.com"; //这里是预发布环境，护士帮帮护士

if (process.env.NODE_ENV === "development") {
  useApiUrl = devApiUrl;
} else {
  //production
  switch (process.env.VUE_APP_MODE) {
    case "buildLoca":
      useApiUrl = buildLocaApiUrl;
      break;
    case "buildDev":
      h5LoginSystemUrl = "http://39.105.181.235:8088/webs/106/#/";
      useApiUrl = buildDevApiUrl;
      break;
    case "buildTest":
      useApiUrl = buildTestApiUrl;
      h5LoginSystemUrl = "http://39.105.181.235:8088/webs/107/#/";
      break;
    case "buildPre":
      useApiUrl = buildPreApiUrl;
      h5LoginSystemUrl = "https://mw.hulian120.com/105/#/";
      break;
    default:
      isRelease = true;
      useApiUrl = buildProApiUrl;
      h5LoginSystemUrl = "https://opacts.hulian120.com/h5login/#/";
      appDownloadUrl = "https://hsj5m.hulian120.com/download.html";
      wxApiUrlPrefix = "https://wxauth.hulian120.com"; //正式，护士加
      break;
  }
}

export {
  isRelease,
  useApiUrl,
  wxApiUrlPrefix,
  appDownloadUrl,
  h5LoginSystemUrl
}; //可以导出更多需要不同环境区分的url
